import ReactHowler from "react-howler";
import { NavLink, useLocation } from "react-router-dom";
import { useState } from "react";
import '../styles/ui.scss'

const Nav = () => {

  const [mobileView, setMobileView] = useState(false)
  const [volume, setVolume] = useState(0)

  const cycleVolume = () => {
    volume < 2 ? setVolume(volume+1) : setVolume(0)
  }

  const location = useLocation();
  const isSystemActive = location.pathname.startsWith('/system');

  return (
    <>
      <div className={`hamburger-menu ${mobileView && "hamburger-open"}`} onClick={()=>setMobileView(!mobileView)}>
        <span className="block top"></span>
        <span className="block middle"></span>
        <span className="block bottom"></span>
      </div>
      <nav className={`nav-container ${mobileView && "nav-open"}`}>
        <NavLink onClick={()=>setMobileView(false)} to="" className="nav-link">
          <h2 className="gradient-text">
            Top
          </h2>
          <span className="brush-stroke b1"/>
        </NavLink>
                <NavLink onClick={()=>setMobileView(false)}  to="whats-new" className="nav-link">
          <h2 className="gradient-text">
             What's New
          </h2>
          <span className="brush-stroke b1"/>
        </NavLink>
        <NavLink onClick={()=>setMobileView(false)}  to="pirilikas-guide" className="nav-link">
          <h2 className="gradient-text">
            Pirilika's Guide
          </h2>
          <span className="brush-stroke b2"/>
        </NavLink>
        <NavLink onClick={()=>setMobileView(false)}  to="story" className="nav-link">
          <h2 className="gradient-text">
            Story
          </h2>
          <span className="brush-stroke b2"/>
        </NavLink>
        <NavLink onClick={()=>setMobileView(false)}  to="characters" className="nav-link">
          <h2 className="gradient-text">
            Characters
          </h2>
          <span className="brush-stroke  b2"/>
        </NavLink>
        <NavLink onClick={()=>setMobileView(false)} to="system/combat" className={isSystemActive ? "active nav-link" : "nav-link"}>
          <h2 className="gradient-text">
            System
          </h2>
          <span className="brush-stroke b1"/>
        </NavLink>
        <NavLink onClick={()=>setMobileView(false)}  to="products" className="nav-link">
          <h2 className="gradient-text">
            Products
          </h2>
          <span className="brush-stroke b2"/>
        </NavLink>
        <NavLink onClick={()=>setMobileView(false)}  to="gallery" className="nav-link">
          <h2 className="gradient-text">
            Gallery
          </h2>
          <span className="brush-stroke  b2"/>
        </NavLink>
        <a href="https://www.nisamerica.com/disgaea/d7-complete/fr" className="french-button" target="_blank" rel="noopener noreferrer">
          <button>
            Textes : <span className="first">ENG</span> / <span className="second">FR</span>
          </button>
        </a>
        <button className={`bgm-button vol-${volume}`} 
          onClick={()=>{cycleVolume()}}
        >
          <ReactHowler
            src={`${process.env.PUBLIC_URL}/sound/bgm.mp3`}
            playing={volume > 0}
            loop={true}
            volume={0.8 * (volume / 2)}
          />
        </button>
      </nav>
    </>
  )
}

export default Nav;